import { downloadBlob } from '../util/downloadBlob';


export async function getUtilizationReportTotalLoginsByTime(timePeriod) {
	const url = `${process.env.REACT_APP_API_URL}Analytics/Logins/Total?timefilter=` + timePeriod;
	const response = await fetch(url, {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
};

export async function getUtilizationReportPdfGeneratedByTime(timePeriod) {
	const url = `${process.env.REACT_APP_API_URL}Analytics/Documents/TotalByAction?timefilter=` + timePeriod;
	const response = await fetch(url, {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
};

export async function getLoginsByProduct(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Logins`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}


export async function getUtlizationLeaderboardData(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Logins/Leaderboard`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getUniqueLoginsByProduct(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Logins/Unique`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getLoginsByPDFAction(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Logins/PDFAction`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getProductsByMessageType(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/GenerationsByMessageType`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getQuicksheetsByActionType(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Quicksheets/PdfAction`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getGenerationsByIndication(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Documents/ByIndication`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getGenerationsByProduct(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Documents/ByProduct`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getGenerationsByUniqueProvider(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Documents/ByUniqueProviders`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getTopHighlightedPlansData(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Documents/TopHighlightedPlans`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getPdfGeneratedEngagementLeaderboardData(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Documents/Generations/Leaderboard`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getActionByProduct(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Documents/ActionsByProduct`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}

export async function getExportdDataCSV(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/Export`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		const blob = await response.blob();
		const contentDispostion = response.headers.get('content-disposition');
		let filename = 'UtilizationExport_' + props.startDate + '_' + props.endDate + ".zip";
		const regex = /filename="?(.+?)"?(\s|;|$)/;

		const match = contentDispostion?.includes('filename=') ? regex.exec(contentDispostion) : null;
		if (match?.[1]) {
			filename = match[1];
		}

		downloadBlob(blob, filename);

	} else {
		throw response.statusText;
	}
}

export async function getUserLeaderboardStatsData(props) {
	let url = `${process.env.REACT_APP_API_URL}Analytics/User/Leaderboard`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(props)
	})

	if (response.status === 200) {
		return await response.json();
	} else {
		throw response.statusText;
	}
}